import React from 'react';
import { FaFlask } from 'react-icons/fa';
import { useAppSettings } from '../context/AppSettingsContext';

// Shared shell for Login / ForgotPassword / ResetPassword — keeps the
// brand lockup and decorative backdrop in one place so all three (and
// any future app built from this one) stay visually identical.
const AuthLayout = ({ children }) => {
  const { appName, clientName, logoUrl } = useAppSettings();

  return (
    <div className="login-container">
      <div className="login-decor-circle top-right" />
      <div className="login-decor-circle bottom-left" />
      <div className="login-card">
        <div className="login-brand">
          {logoUrl ? (
            <img src={logoUrl} alt={appName} className="login-brand-logo-img" />
          ) : (
            <>
              <span className="login-brand-icon"><FaFlask /></span>
              <span className="login-brand-text">
                <span className="login-brand-name">{appName}</span>
                <span className="login-tagline">Cleaning Validation Management</span>
              </span>
            </>
          )}
        </div>
        {clientName && <div className="login-client-name">{clientName}</div>}
        {children}
      </div>
      <div className="login-footer">
        Powered by {appName} &copy; {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default AuthLayout;
